import { ITransferApplyClient, IPostInput, IPostResponse } from 'interfaceAdapter/gatewaySchemas/ITransferApplyClient';
import { API_LOCATION_URL } from 'infrastructure/config';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class TransferApplyClient implements ITransferApplyClient {
    public async post(input: IPostInput): Promise<IPostResponse> {
        const PATH = `${API_LOCATION_URL}/supporter/transfer/apply`;
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': input.token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        try {
            const { token, ...bodyData } = input;
            const response = await fetch(PATH, {
                method: 'POST',
                headers,
                body: JSON.stringify(bodyData),
            });

            const { data, message } = await response.json();
            return { data, message };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
